import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class EnsureAuthenticatedService implements CanActivate {

  constructor(private router: Router) { }

  canActivate() {
    if (localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')) {
      // checar en la base si el token esta activo
      return true;
    }else{
      this.router.navigateByUrl('/login');
      return false;
    }
  }
}
